import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className='min-h-[750px] bg-black w-full px-6 py-10 lg:p-16 grid grid-cols-1 sm:grid-cols-2 gap-y-8 '>
        <section className='w-full sm:w-8/12 mx-auto flex flex-col justify-between gap-y-10'>
          <div className='grow flex-1 flex flex-col space-y-14 align-middle' >
            <div className='space-y-8'>
              <div className='flex gap-x-2 place-items-center'>
                <span className='w-3 h-3 rounded-full bg-[#1b1222]'></span>
                <p className='uppercase text-[#434343] text-xs tracking-wide tf-inter font-light'>ABIYAMO</p>
              </div>

              <div className='flex flex-col gap-y-10 mb-'>
                <Link to={'/projects'} className='text-3xl text-[#D0D0C8] tf-inter'>Projects</Link>
                <Link to={'/about'} className='text-3xl text-[#D0D0C8] tf-inter'>About Us</Link>
              </div>
              
            </div>

            {/* <div className='space-y-8'>
              <div className='flex gap-x-2 place-items-center'>
                <span className='w-3 h-3 rounded-full bg-[#474747cb]'></span>
                <p className='uppercase text-[#474747cb] text-xs tracking-wide tf-inter font-light'>About us</p>
              </div>

              <div className='flex flex-col gap-y-2 mb-48'>
                <Link to={'/about'} className='text-xl text-[#D0D0C8] tf-inter'>About</Link>
                <Link to={'/contact-us'} className='text-xl text-[#D0D0C8] tf-inter'>Contact Us</Link>
              </div>
            </div> */}
          </div>
          <small className='text-xs text-[#424242] tf-inter'>&copy; {new Date().getFullYear()} — Copyright</small>
        </section>

        <section className='h-full'>
          <div className='w-full h-2 bg-white'></div>

          <div className='flex h-full flex-row justify-between'>
            <div className='flex flex-col mt-10 justify-between'>
              <div className='grow flex-1 space-y-10'>
                <div>
                  <div className='mb-4 flex flex-row gap-x-2 place-items-center'>
                    <span className='w-3 h-3 rounded-full bg-[#474747cb]'></span>
                    <p className='uppercase text-[#434343] text-xs tracking-wide tf-inter font-light'>Contact US</p>
                  </div>

                  <span className='flex flex-col gap-y-2'>
                    <a  className='text-xs text-white tf-inter' href="tel:+2348087414122">+234 808 741 4122</a>
                    <a href="mailto:support@abiyamogboja.com" className='text-xs text-white tf-inter'>support@abiyamogboja.com</a>
                  </span>
                </div>

                <div>
                  <div className='mb-4 flex flex-row gap-x-2 place-items-center'>
                    <span className='w-3 h-3 rounded-full bg-[#474747cb]'></span>
                    <p className='uppercase text-[#434343] text-xs tracking-wide tf-inter font-light'>Location</p>
                  </div>

                  <span className='flex flex-col gap-y-2'>
                    <small className='text-xs text-white tf-inter'>14 Oladepopu fafore street by santos estate dopemu akowonjo, lagos</small>
                    <h2 className='text-lg text-white tf-inter font-extrabold'>10am — 4pm</h2>
                    <small className='text-[#5d5d5d] text-xs'>/ Monday - Friday</small>
                  </span>
                </div>
              </div>

              <small className='text-xs text-[#424242] tf-inter'>privacy</small>
            </div>
          </div>
        </section>
      </footer>
  )
}

export default Footer